// extracted by mini-css-extract-plugin
export var box = "_22-1";
export var checkboxRow = "_22-8";
export var checked = "_22-2";
export var descriptionSpacer = "_22-a";
export var disabled = "_22-3";
export var icon = "_22-6";
export var input = "_22-0";
export var labelSpacer = "_22-9";
export var medium = "_22-5";
export var small = "_22-4";
export var text = "_22-7";